import * as CryptoJS from 'crypto-js';
import { AlgoType, VwEncryptionService } from 'vwappservices';

export class SdcEncryptionService implements VwEncryptionService {
  defaultEncryptionAlgorithm: AlgoType = 'NONE';
  private readonly key = 'viotalworkspvtltd';

  encryptData(data: string, _algo: AlgoType): string {
    return CryptoJS.AES.encrypt(data, this.key).toString();
  }

  decryptData(data: any, _algo: AlgoType): any {
    if (!data) return data;
    const cipher = data.toString().replaceAll(/ /g, '+');
    const bytes = CryptoJS.AES.decrypt(cipher, this.key);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
